import { Poppins, Quicksand } from 'next/font/google'
import React, { Component } from 'react'
const popins = Poppins({weight:"500" , subsets:['latin']})
const quickSand = Quicksand({weight:"500" , subsets:['latin']})
export class Blogcontent extends Component {
  render() {
    return (
     <>
      {this.props.blog.map((blog,i)=>{
            return(
                <div key={i}>
                <div className="">
                <h2 className={`fs-33 mfs20  pdb10 pdt20 ${popins.className}`}>{blog.title}</h2>
                {blog.content.map((content,i)=>{
                return(
                <div key={i} className="df">
                <p className={`fs18 mfs14 lh3 pdb10 ${quickSand.className}`}>{content}</p>
                </div>
                )})}
                </div>
                </div>
            )
          })}
     </>
    )
  }
}

export default Blogcontent